/** @format */

import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router";
import Loader from "../../Components/Loader";
import masterServices from "../../Services/masterService";
import { useLocation } from "react-router-dom";
import CheckAccess from "../../Function/CheckAccess";

export const StorageList = () => {
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState({});
  const history = useHistory();
  const imgRef = useRef();

  useEffect(() => {
    getItemList();
  }, []);

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  // const { id } = useParams();
  // console.log(id, "iiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii")

  const singleId = history.location.search;

  const getItemList = () => {
    masterServices.get_storage().then((res) => {
      if (res.status) {
        setData(res);
        setLoader(false);
        // setPagination(res.pagination)
      } else {
        setLoader(false);
      }
    });
  };
  //   getItemList()

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-end mb-3">
              {(CheckAccess(211,"edit") || user_type === "SUPERADMIN") && (
                <button
                  className="btn btn-primary w-sm waves-effect waves-light mx-3"
                  onClick={() =>
                    history.push("/edit-storage?id=" + data.data._id, data)
                  }
                >
                  Edit Storage
                </button>
              )}

              <input ref={imgRef} type="file" className="d-none" />
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0 table-striped">
                <thead className="table-light">
                  <tr>
                    <th>Tariff</th>
                    <th>Rate/aed</th>
                    <th>UOM</th>
                  </tr>
                </thead>
                <tbody>
                  {data.data &&
                    data.data.storages &&
                    data.data.storages.map((item, key) => (
                      <tr key={key}>
                        <td>{item.tarrif.split("_").join(" ")}</td>
                        <td>{item.rate ? item.rate : "-"}</td>
                        <td>{item.UOM ? item.UOM : "-"}</td>
                      </tr>
                    ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="2" align="right">
                      <b>Overall Total Minimum</b>
                    </td>
                    <td colSpan="2">
                      <b>{data.data && data.data.minimum}</b>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
  );
};
